// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.easycommerce-report-product-search {
    font-size: 16px;
    font-weight: 400;
    line-height: 26px !important;
    color: var(--color-ec-body) !important;
    border: none !important;
    background: none !important;
}
.easycommerce-report-product-search:focus {
    box-shadow: none !important;
    outline: none !important;
    border: none !important;
}
.easycommerce-report-product-search::-moz-placeholder {
    color: var(--color-ec-placeholder) !important;
}
.easycommerce-report-product-search::placeholder {
    color: var(--color-ec-placeholder) !important;
}
`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/pages/Reports/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;IAChB,4BAA4B;IAC5B,sCAAsC;IACtC,uBAAuB;IACvB,2BAA2B;AAC/B;AACA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,uBAAuB;AAC3B;AACA;IACI,6CAA6C;AACjD;AAFA;IACI,6CAA6C;AACjD","sourcesContent":[".easycommerce-report-product-search {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 26px !important;\n    color: var(--color-ec-body) !important;\n    border: none !important;\n    background: none !important;\n}\n.easycommerce-report-product-search:focus {\n    box-shadow: none !important;\n    outline: none !important;\n    border: none !important;\n}\n.easycommerce-report-product-search::placeholder {\n    color: var(--color-ec-placeholder) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
